<div class="main-theme pb-5">
    <div class="container">
        <div class="row">
            <div class="col-3"></div>
            <div class="col-6 text-center">
                <h1 class="notfound-title">404</h1>
                <h2 class="notfound-subtitle">{{'PAGINA_NON_TROVATA' | translate}}</h2>
                <p class="mt-4" [innerHtml]="'PAGINA_NON_TROVATA_BODY'|translate |sanitizer:'html'"></p>
                <a *ngIf="!(isAuth)" [routerLink]="['']"
                    class="width-50 btn btn-primary">{{'RITORNA_ALLA_HOMEPAGE' | translate}}</a>
                <a *ngIf="(isAuth)" [routerLink]="['/'+ baseHref + (role != undefined ? role : '')]"
                    class="width-50 btn btn-primary">{{'RITORNA_ALLA_HOMEPAGE' | translate}}</a>
            </div>
        </div>
    </div>
</div>